<p-toast></p-toast>

<div class="card">
  <h2>Registro de Hospital</h2>
  
  <form [formGroup]="hospitalForm" (ngSubmit)="onSubmit()">
    <div class="formgrid grid">      
          <!-- Nombre Hospital -->
        <div class="field col-12 md:col-6">
        <label for="nomHospital">Nombre del Hospital</label>
        <input 
          id="nomHospital"
          type="text"
          pInputText
          formControlName="nomHospital"
          class="text-base text-color surface-overlay p-2 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
          [ngClass]="{'ng-invalid ng-dirty': f['nomHospital'].touched && f['nomHospital'].errors}">
        <small class="p-error" *ngIf="f['nomHospital'].touched && f['nomHospital'].errors?.['required']">
          El nombre del hospital es requerido
        </small>
        <small class="p-error" *ngIf="f['nomHospital'].touched && f['nomHospital'].errors?.['minlength']">
          El nombre debe tener al menos 3 caracteres
        </small>
        </div>
        <div class="field col-12 md:col-6"></div>
          <!-- Direccion Hospital -->
        <div class="field col-12 md:col-6">
            <label for="direccion">Direccion</label>
            <input 
              id="direccion"
              type="text"
              pInputText
              formControlName="direccion"
              class="text-base text-color surface-overlay p-2 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
             >
        </div> 
          <!-- Telefono Hospital -->
        <div class="field col-12 md:col-6">
            <label for="telefono">Telefono</label>
            <input 
              id="telefono"
              type="text"
              pInputText
              formControlName="telefono"
              class="text-base text-color surface-overlay p-2 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary"
             >
        </div>    
          <!-- Clave Institución -->
        <div class="field col-12 md:col-6">
        <label for="cvInstitucion">Institución</label>
        <p-dropdown
        id="institucion"
        [options]="instituciones"
        formControlName="fk_institucion"
        optionLabel="nomInstitucion"
        [showClear]="true"
        placeholder="Seleccione una institución"
        [ngClass]="{'ng-invalid ng-dirty': f['fk_institucion'].touched && f['fk_institucion'].errors}">
      </p-dropdown>
      <small class="p-error" *ngIf="f['fk_institucion'].touched && f['fk_institucion'].errors?.['required']">
        El estado es requerido
      </small>
        
        </div>
          <!-- Estado -->
        <div class="field col-12 md:col-6">
        <label for="estado">Estado</label>
        <p-dropdown
          id="estado"
          [options]="estados"
          formControlName="fk_estado"
          optionLabel="nomEstado"
          [showClear]="true"
          placeholder="Seleccione un estado"
          [ngClass]="{'ng-invalid ng-dirty': f['fk_estado'].touched && f['fk_estado'].errors}">
        </p-dropdown>
        <small class="p-error" *ngIf="f['fk_estado'].touched && f['fk_estado'].errors?.['required']">
          El estado es requerido
        </small>
       </div>      
    </div>
     <!-- Botones -->
    <div class="field col-12 md:col-4">
        <p-button 
        type="submit"
        label="Guardar"
        icon="pi pi-save"
        [disabled]="hospitalForm.invalid">
      </p-button>
    </div> 
  </form>
  
</div>
